import {
  createPlugin,
  createRoutableExtension,
  createRouteRef,
} from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'vivicta-application-portal',
});

export const lifecycleRouteRef = createRouteRef({
  id: 'vivicta-application-lifecycle',
});

export const applicationPortalPlugin = createPlugin({
  id: 'vivicta-application-portal',
  routes: {
    root: rootRouteRef,
    lifecycle: lifecycleRouteRef,
  },
});

export const ApplicationPortalPage = applicationPortalPlugin.provide(
  createRoutableExtension({
    name: 'ApplicationPortalPage',
    component: () =>
      import('./components/ApplicationPortalPage').then(
        m => m.ApplicationPortalPage,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const ApplicationLifecyclePage = applicationPortalPlugin.provide(
  createRoutableExtension({
    name: 'ApplicationLifecyclePage',
    component: () =>
      import('./components/ApplicationLifecyclePage').then(
        m => m.ApplicationLifecyclePage,
      ),
    mountPoint: lifecycleRouteRef,
  }),
);
